import moment from 'moment'
import React from 'react'
import { IProductVisibilityRecord } from '../models/models'

// SAP tarafında bitiş tarihi 99991231000000 ("süresiz") gelebiliyor; backend boş/bozuk tarihleri
// de sınırsız kabul ederek DateTime.MinValue / MaxValue döndürüyor.
export const formatVisibilityDate = (date?: Date, isEndDate = false) => {
  if (!date) return isEndDate ? 'Süresiz' : '-'

  const value = moment(date)
  if (!value.isValid()) return '-'

  if (value.year() >= 9999) return isEndDate ? 'Süresiz' : '-'
  if (value.year() <= 1) return '-'

  return value.format('DD.MM.YYYY HH:mm:ss')
}

interface Props {
  records: IProductVisibilityRecord[]
}

/**
 * SAP ürün gizlilik kayıtlarının tablo görünümü. "Ürün Gizlilik Kayıtları" listesi ile
 * "Ürün Bilgisi Sorgulama" ekranındaki görünürlük modalı aynı bileşeni kullanır.
 */
export default function VisibilityRecordsTable({ records }: Props) {
  return (
    <table className='table'>
      <thead>
        <tr role='row' className='odd'>
          <th>ID</th>
          <th>Şirket</th>
          <th>Bayi Kodu</th>
          <th>Bayi Adı</th>
          <th>Kural</th>
          <th>Başlangıç Tarihi</th>
          <th>Bitiş Tarihi</th>
          <th>Not</th>
        </tr>
      </thead>
      <tbody>
        {records && records.length > 0 ? (
          records.map(record => (
            <tr role='row' className='odd' key={record.Id}>
              <td>{record.Id}</td>
              <td>{record.Company}</td>
              <td>{record.DealerCode ? record.DealerCode : '-'}</td>
              <td>{record.DealerName ? record.DealerName : '-'}</td>
              <td>{record.FlagsText}</td>
              <td>{formatVisibilityDate(record.StartDate)}</td>
              <td>{formatVisibilityDate(record.EndDate, true)}</td>
              <td>{record.Notes}</td>
            </tr>
          ))
        ) : (
          <tr role='row' className='odd'>
            <td colSpan={8}>Kayıt bulunamadı.</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}
